import React from 'react'
import BaseField from 'mz-ui-kit/core/BaseField';
import SwitchField from 'mz-ui-kit/form/SwitchField';
import { Container } from './elements'


const RoundtripSwitchField = (baseProps) => (
  <BaseField {...baseProps} renderInput={({ props }) => (
    <Container>
      <SwitchField {...props} appearance="primary" label={null} />
    </Container>
  )} />
)

export default RoundtripSwitchField
